"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// import base64 from 'base-64';
var base64 = require('base-64');
exports.encode = function (obj) {
    if (typeof obj === 'object') {
        return base64.encode(JSON.stringify(obj));
    }
    return base64.encode(obj);
};
exports.decode = function (str) { return base64.decode(str); };
//# sourceMappingURL=encoder.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-sdk/dist/src/utils/encoder.js
// module id = 388
// module chunks = 0 1